import PropTypes from 'prop-types';
import { Container } from '@mui/material';

CustomContainer.propTypes = {
  maxWidth: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  py: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.number]),
  sx: PropTypes.instanceOf(Object),
};

CustomContainer.defaultProps = {
  maxWidth: 'xl',
  py: { xs: 5, md: 8 },
  sx: {},
};

export default function CustomContainer({ maxWidth, children, py, sx }) {
  return (
    <Container
      disableGutters
      maxWidth={maxWidth}
      sx={{
        px: { xs: 2, sm: 4, md: 8, lg: 14, xl: 27 },
        py,
        ...sx,
      }}
    >
      {children}
    </Container>
  );
}
